import React, {useEffect, useState} from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import { useSelector, shallowEqual } from 'react-redux'
import WeeklySchedule from '../../../screens/parent/weekly-schedule';
import * as S from './style'
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import {getItemFromLocalStorage, sendEventUsingAvo, setItemInLocalStorage } from '../../../utils/web-helper';

const WeeklyGoalScreen = ({isNextStep, goToNextHandler}) => {
  const { childScreenName, selectedSubject} = useSelector(state => state, shallowEqual);

  const [animate, setAnimate] = useState(false);
  const { deleteAll, getItem } = useExtendedLocalStorage('splashverse-onboarding', '');
  const childId = getItem('childId');
  const fromLandingPageOnboarding =  getItemFromLocalStorage('viaOnboarding') &&  getItemFromLocalStorage('from_landing_page');

  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 100);

    !fromLandingPageOnboarding && setItemInLocalStorage('redirect_to_purchase', true);
    setItemInLocalStorage('live_class_tab_visible', true);
  }, []);

  const submitCallbackHandler = (skippedOnboarding = false) =>{
    goToNextHandler('weekly_goal_screen',{selectedSubject, deleteAll, skippedOnboarding: skippedOnboarding})
  }

  const skipSubmitHandler = async () => {
    try {
      sendEventUsingAvo({
        methodName: 'weeklyGoalInteracted',
        params: {
          clickedOn: 'skip'
        }
      })
      !fromLandingPageOnboarding && setItemInLocalStorage('redirect_to_purchase', true);
      submitCallbackHandler(true);
    }
    catch(e) {
      console.log('Error in API', e);
    }
  }

  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
          <SS.StepHeader>
            { `Help ${childScreenName} build a learning habit`}

          </SS.StepHeader>
           <SS.StepSubheader>
            {`Receive timely notifications so ${childScreenName} never misses practice. Modify anytime.`}
          </SS.StepSubheader>
          <div className="dashboard splash-verse">
            <S.ComponentContainer className="parent-onboarding add-child-details new-onboarding">
                <WeeklySchedule hideBackBtn={true} hideWeeklyScheduleHeader={true} submitCallbackHandler= {submitCallbackHandler} childId = {childId}/>
            </S.ComponentContainer>
          </div>
          <S.SkipCta onClick={() => skipSubmitHandler()}>
            Skip for now
          </S.SkipCta>
        </SS.OnboardingStepWrapper>
      )}
    </Transition>
  )
}

export default WeeklyGoalScreen;